import { registerPlugin } from '@capacitor/core';

import type { SfmcMobilePushPlugin } from './definitions';

const SfmcMobilePush = registerPlugin<SfmcMobilePushPlugin>('SfmcMobilePush', {
  web: () => import('./web').then(m => new m.SfmcMobilePushWeb()),
});

export * from './definitions';
export { SfmcMobilePush };
